import React, { Component } from 'react';
import { Link } from "react-router-dom";
import DeviceController from "../../../models/device/deviceController";
import {
  DEVICE_WET_STATUS,
  statusActive, statusInactive,
  statusInRange, statusOutOfRange,
  statusDry, statusWet, deviceWetMoreThanTwentyFourHours,
  APP_COLOR, exists
} from "../../../util/util";
import {MIN_WET_LOGS_TO_DISPLAY} from "../../../api/constants";
import './DeviceItem.css';

// icons
import InfoIcon from 'material-ui/svg-icons/action/info';
import DryBedIcon from '../../images/bed-dry.png';
import SemiDryBedIcon from '../../images/bed-semi-dry.png';
import WetBedIcon from '../../images/bed-wet.png';
import WetAlertBedIcon from '../../images/bed-wet-alert.png';
import WetMoreThanTwentyFourHoursBedIcon from '../../images/bed-wet-more-than-24h.png';
import InactiveBedIcon from '../../images/bed-inactive.png';
import EmptyBedIcon from '../../images/bed-empty.png';
import FeetIcon from '../../images/out-of-range.png';

class DeviceItem extends Component {

  render() {

    let { device } = this.props;
    
    let bedIcon = this._setDeviceBedIcon(device);
    let statusIcons = statusOutOfRange(device) ? <img src={FeetIcon} alt="feet"/> : '';
    let deviceColor = statusOutOfRange(device) ? APP_COLOR.RED : APP_COLOR.LIGHT_GRAY;
    let infoIconColor = exists(device.noOfWetStatuses) && device.noOfWetStatuses >= MIN_WET_LOGS_TO_DISPLAY ? APP_COLOR.GREEN : APP_COLOR.BLUE;
    let statusChartLink = `logs/devices/${device.id}`;
    
    return(
      <div className="device clearfix">
        <div className="status-color-wrapper" style={{ backgroundColor: deviceColor }}>
          <div className="visual">
            <div className="bed-icon">
              {bedIcon}
            </div>
            <div className="under-bed-icon">
              {statusIcons}
            </div>
          </div>
          <div className="vertical-divider" />
          <div className="info">
            <div className="info-section">
              <div className="description">
                {this._renderDescription(device)}
              </div>
            </div>
            <div className="horizontal-divider" />
            <div className="info-section clearfix">
              <div className="time">
                {this._renderLastLogTime(device)}
              </div>
              <div className="vertical-divider" />
              <div className="info-button">
                <Link to={statusChartLink}>
                  <InfoIcon className="center-element" style={{width:"44px",height:"44px",color:infoIconColor,background:"#ffffff",borderRadius:"50%"}} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  _renderDescription(device) {
    return device.description ? <span className="center-element">{this._setDescription(device)}</span> : "";
  }
  
  _setDescription(device) {
    
    let descParts = device.description.split(",");
    
    let partsTotal = descParts.length;
    
    return descParts.map((item, key) => {
      
      return ((partsTotal - 1) !== key) ? <span key={key}>{item},<br/></span> : <span key={key}>{item}</span>;
    })
  }
  
  _renderLastLogTime(device) {
    
    let lastLogTime = DeviceController._getLastLogTime(device);
  
    let logDate,logTime;
    if(lastLogTime) {
      logDate = lastLogTime.date;
      logTime = lastLogTime.time;
    }
    
    return(<span className="center-element">{logDate}<br />{logTime}</span>);
  }
  
  _setDeviceBedIcon(device) {
    
    if(statusActive(device)) {
      
      if(statusInRange(device)) {
        
        if(statusDry(device)) {
          return <img src={DryBedIcon} alt="dry bed" />;
        }
        else if(statusWet(device)) {
          
          if(deviceWetMoreThanTwentyFourHours(device)) {
            return <img src={WetMoreThanTwentyFourHoursBedIcon} alt="wet more than 24h" />;
          }
          else {
  
            let wetStatus = DeviceController._setWetStatus(device);
  
            switch (wetStatus) {
              case DEVICE_WET_STATUS.SEMI_DRY:
                return <img src={SemiDryBedIcon} alt="semi dry bed" />;
              case DEVICE_WET_STATUS.WET:
                return <img src={WetBedIcon} alt="wet bed" />;
              case DEVICE_WET_STATUS.WET_ALERT:
                return <img src={WetAlertBedIcon} alt="wet alert bed" />;
              default:
                return null;
            }
            
          }
        }
      }
      else if(statusOutOfRange(device)) {
        return <img src={EmptyBedIcon} alt="empty bed icon"/>;
      }
    }
    else if(statusInactive(device)) {
      return <img src={InactiveBedIcon} alt="inactive bed icon" />;
    }
    else{
      return <img src={InactiveBedIcon} alt="inactive bed icon" />;
    }
  }
}

export default DeviceItem;


// WEBPACK FOOTER //
// ./src/common/components/DeviceItem/DeviceItem.js